// extracted by mini-css-extract-plugin
export default {"thankYouTitle":"XPAqNL"};